import React from "react";
import "./styles.css";
import { config } from "../../../config";

export const ProgressBar = ({
  color,
  completed,
  className,
  isLsb,
  value,
  simulation,
  isActive
}) => {
  const valueBlock = React.useRef(null);
  const bar = React.useRef(null);

  const valueBlockWidth = valueBlock.current?.offsetWidth;
  const barWidth = bar.current?.offsetWidth;

  const blockPercentage = (valueBlockWidth / 2 / barWidth) * 100;

  const fillerStyles = {
    width: `${completed}%`,
    backgroundColor: color
  };

  let leftStyle = completed;
  if (leftStyle <= 0) {
    leftStyle = 0;
  }
  if (leftStyle + blockPercentage * 2 >= 90) {
    leftStyle = leftStyle - blockPercentage * 2;
  }

  const valueStyles = {
    left: `${leftStyle}%`
  };

  const wrapperClassName = className
    ? `${className} progress-bar-wrapper`
    : "progress-bar-wrapper";

  return (
    <div className={wrapperClassName}>
      <div ref={bar} className="progress-bar-body">
        {simulation && isActive && !isLsb && (
          <div
            style={valueStyles}
            ref={valueBlock}
            className="progress-bar-count"
          >
            {value}
          </div>
        )}
        {isLsb && (
          <div className="progress-bar-lsb">{config.orders.notPresented}</div>
        )}
        <div style={fillerStyles} className="progress-bar-inner" />
      </div>
    </div>
  );
};
